import { render } from "./WidgetSection.vue?vue&type=template&id=b9073a20"
import script from "./WidgetSection.vue?vue&type=script&lang=js"
export * from "./WidgetSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__